import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import { EMPLOYEE_NUMBER_OF_HOLIDAYS } from '../../constants/employeeNumberOfHolidays.js';
import type { Anstellungsform } from '../../enums/Anstellungsform.js';
import type { BesonderePersonengruppe } from '../../enums/BesonderePersonengruppe.js';
import type { PauschalbesteuerungMiniJob } from '../../enums/PauschalbesteuerungMiniJob.js';
import { Probezeit } from '../../enums/Probezeit.js';

@Entity()
export class AGInfos extends AdornisEntity {
  static override _class = 'AGInfos';

  @Field(type => Date)
  unterzeichnungsdatum: Maybe<Date>;

  @Field(type => Date)
  einstellungsdatum: Maybe<Date>;

  @Field(type => Date)
  gekuendigtZum: Maybe<Date>;

  @Field(type => Boolean, { default: v => v ?? false })
  alleDokumenteVorgelegt!: boolean;

  @Field(type => Float, { default: v => v ?? EMPLOYEE_NUMBER_OF_HOLIDAYS })
  urlaubsTage!: number;

  @Field(type => String)
  anstellungsform: Maybe<Anstellungsform>;

  @Field(type => String)
  pauschalbesteuerungMiniJob: Maybe<PauschalbesteuerungMiniJob>;

  @Field(type => String, { default: v => v ?? Probezeit.HALBJAHR })
  dauerProbezeit: Maybe<Probezeit>;

  @Field(type => String)
  besonderePersonengruppe: Maybe<BesonderePersonengruppe>;

  @Field(type => String)
  nebenabrede: Maybe<string>;

  @Field(type => Boolean, { default: v => v ?? false })
  isGestellungsContract: Maybe<boolean>;

  @Field(type => Boolean, { default: v => v ?? false })
  workingStudentChecked: Maybe<boolean>;
}

if (A.isClient) {
  AGInfos.prototype.validator = new Validator({
    unterzeichnungsdatum: options => (options.simpleValidation ? (() => {})() : nonOptional()(options)),
    einstellungsdatum: nonOptional(),
    urlaubsTage: options => (options.simpleValidation ? (() => {})() : nonOptional()(options)),
  });
}
